import { ClickEvent, Label, Layout, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutDriverManagementEventsTable } from "./autogen/AutogenLayoutDriverManagementEventsTable";
import { ModelRow } from "@mcleod/core";
import { DriverEventSlideout } from "../../DriverEventSlideout";

export class DriverManagementEventsTable extends AutogenLayoutDriverManagementEventsTable {
    public driverId: string;
    public driverName: string;
    public driverMgrId: string;
    public driverMgrName: string;

    onLoad(): void | Promise<void> {
        this.sourceDriverEvents.orderBy = [{ field: "start_date", sort: "asc" }];
    }

    tableDriverEventsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const data = tableRow.data as ModelRow;
        const labelComments = tableRow.findComponentById("labelRemark") as Label;
        if (labelComments) {
            labelComments.tooltip = data?.getString("remark", null);
        }
    }

    buttonAddDriverEventOnClick(event: ClickEvent) {
        const layout = Layout.getLayout("lme/dispatch/DriverEventSlideout") as DriverEventSlideout;
        const slideOut = new DriverEventSlideout();
        slideOut.showSlideout({
            equipmentId: this.driverId,
            equipmentName: this.driverName,
            driverMgrId: this.driverMgrId,
            driverMgrName: this.driverMgrName,
            doAfterSave: () => {
                this.mainDataSource.search({
                    equipment_id: this.driverId,
                    equipment_type_id: "D",
                    event_status: "in A,U"
                });
            }
        });
    }
}
